import { render, staticRenderFns } from "./salesStatisticsDetail.vue?vue&type=template&id=2e690b6d&scoped=true&"
import script from "./salesStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./salesStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./salesStatisticsDetail.vue?vue&type=style&index=0&id=2e690b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e690b6d",
  null
  
)

export default component.exports